import LongText from '../Elements/LongText';
import React from 'react';

export default class TpEvaluatorEmailCampaignItem {
  constructor(item) {
    if (item == null) {
      this.ThirdPartyEvaluatorId = 0;
      this.ThirdPartySource = '';
      this.FirstName = '';
      this.LastName = '';
      this.AccountStatus = '';
      this.Email = '';
      this.Gender = '';
      this.ProfileLanguage = '';
      return;
    }
    this.ThirdPartyEvaluatorId = item.thirdPartyEvaluatorId;
    this.ThirdPartySource = item.thirdPartySources ? item.thirdPartySources.join(', ') : '';
    this.FirstName = item.firstName;
    this.LastName = item.lastName;
    this.AccountStatus = item.accountStatus;
    this.Email = item.email;
    this.Gender = item.gender;
    this.ProfileLanguage =
      (item.profileLanguages && item.profileLanguages.length === 1) || !item.apolloLanguage
        ? item.profileLanguages?.join(', ')
        : item.apolloLanguage;
  }

  static NameOfTheIdField() {
    return 'ThirdPartyEvaluatorId';
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: (item) => (
          <LongText
            text={item.ThirdPartySource}
            maxLength={30}
          />
        ),
        minWidth: '120px',
      },
      { label: 'First Name', orderById: 'FirstName', data: 'FirstName', minWidth: '100px' },
      { label: 'Last Name', orderById: 'LastName', data: 'LastName', minWidth: '100px' },
      { label: 'Email', orderById: 'Email', data: 'Email' },
      { label: 'Gender', orderById: 'Gender', data: 'Gender' },
      {
        label: 'Profile Language',
        orderById: 'ProfileLanguage',
        data: (item) => (
          <LongText
            text={item.ProfileLanguage}
            maxLength={30}
          />
        ),
      },
    ];
  }
}
